/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'fine' }, { id: 'medium' }, { id: 'thick' }, { id: 'veryThick' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-hair-thickness"
      progress={56}
      field="hairstyleHairThickness"
      setter="setHairstyleHairThickness"
      ns="hairstyleHairThickness"
      options={OPTIONS}
    />
  );
}

export default Page;
